module.exports = __webpack_public_path__ + "img/cuff button diameter.b3a4ac3c.png";